// @flow
import { dateString } from './date';

export type ReportOrdersFormValues = {
  customer: Array<string> | null,
  catalog: Array<string> | null,
  status: Array<'draft' | 'final_submission' | 'review'> | null,
  dateRange: [void | Date, void | Date],
  excludeZeroQty: boolean,
  username: string,
  groupCodes: Array<string>,
};

export type SerializedReportOrders = {
  print_job: {
    _type: 'PrintJob::Report::Forecasting',
    author_name: string,
    date_range: {
      start_date: string | null,
      end_date: string | null,
    },
    job_options: {
      regions: $ReadOnlyArray<string>,
      catalogs: $ReadOnlyArray<string>,
      states: $ReadOnlyArray<string>,
      customers: $ReadOnlyArray<string>,
      group_codes: $ReadOnlyArray<string>,
      product_tags: $ReadOnlyArray<string>,
      reject_zero_units: string | null,
    },
  },
};

export type ReportOrders = SerializedReportOrders;

export const serializeReportOrders = (
  formValues: ReportOrdersFormValues,
): SerializedReportOrders => ({
  print_job: {
    _type: 'PrintJob::Report::Forecasting',
    author_name: formValues.username,
    date_range: {
      start_date: formValues.dateRange[0]
        ? dateString(formValues.dateRange[0])
        : null,
      end_date: formValues.dateRange[1]
        ? dateString(formValues.dateRange[1])
        : null,
    },
    job_options: {
      regions: [],
      catalogs: formValues.catalog ? formValues.catalog : [],
      states: formValues.status
        ? formValues.status
        : ['final_submission', 'draft', 'review'],
      customers: formValues.customer ? formValues.customer : [],
      group_codes: formValues.groupCodes,
      product_tags: [],
      reject_zero_units: formValues.excludeZeroQty ? 'yes' : null,
    },
  },
});

export const deserializeReportOrders = (
  result: SerializedReportOrders,
): ReportOrders => result;
